import React from 'react';
import {
  Box,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import { useHistory } from 'react-router';
import { PlayArrow } from '@material-ui/icons';
import { FaEye } from 'react-icons/fa6';

import { dateTimeBodyRender, entityBaseBodyRender, TableColumn } from '@app/components/common/table';
import { Txt } from '@app/components/common';
import { sortEntityByName } from '@app/utils';
import { MasterOutletUpdate } from '@app/api/models';

import MapViewModal from './map-modal';
import FrequencyVisitsModal from '../new-outlets/frequency-visits-modal';

export const useColumns = ({ canEdit }: { canEdit: boolean }): TableColumn<MasterOutletUpdate>[] => {
  const history = useHistory();
  return [
    {
      name: 'outlet_id',
      label: 'ID мастер-ТТ',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'data',
      label: 'Наименование',
      options: {
        filter: {
          name: 'name',
          type: 'text',
        },
        sort: false,
        customBodyRender: (_, { rowData }) => (
          <>
            <Txt color="brand.500" style={{ fontSize: 16 }}>
              {rowData.data.name}
            </Txt>
            <Box display="flex">
              <Txt color="gray.500">Вывеска:&nbsp;</Txt>
              <Txt>{rowData.data.title}</Txt>
            </Box>
            {!!rowData.data.subnet && <Box display="flex">
              <Txt color="gray.500">Подсеть:&nbsp;</Txt>
              <Txt>{rowData.data.subnet}</Txt>
            </Box>}
          </>
        ),
      },
    },
    {
      name: 'data',
      label: 'Частота посещений в мес.',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => (
          <>
            <FrequencyVisitsModal value={rowData.data.visits_day} />
          </>
        ),
      },
    },
    {
      name: 'data',
      label: 'Канал/Подканал',
      options: {
        filter: {
          name: 'sub_channel_id',
          sourceName: 'outlet_sub_channel',
          type: 'multi-select',
          onOptionsFetch: (channels: EntityBase[]) => sortEntityByName(channels.map(({ id, name, channel }) => {
            return { id, name: `${channel}: ${name}` };
          }))
        },
        sort: false,
        hidden: true,
      },
    },
    {
      name: 'data',
      label: 'Номер маршрута',
      options: {
        filter: {
          name: 'route_number_id',
          sourceName: 'route_number',
          type: 'autocomplete-paginated',
          onApply: (value) => [value?.id]
        },
        sort: false,
        hidden: true,
        // customBodyRender: (_, { rowData }) => (
        //   <>
        //     <Txt>{rowData.data.route_number?.name}</Txt>
        //   </>
        // ),
      },
    },
    {
      name: 'data',
      label: 'Адрес',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => (
          <Flex alignItems='center' minW={200}>
            <MapViewModal
              title={rowData.data.name}
              coords={rowData.data.address?.latlng}
            />
            <Txt wordBreak='break-word' whiteSpace='pre-wrap'>{rowData.data.address?.full_address}</Txt>
          </Flex>
        ),
      },
    },
    {
      name: 'create_dt',
      label: 'Дата создания',
      options: {
        filter: {
          name: 'create_date_range',
          type: 'date-range',
          onApply: (value) => value.map((date) => date.split('T')[0])
        },
        sort: false,
        customBodyRender: dateTimeBodyRender(false, false),
      },
    },
    {
      name: 'user',
      label: 'Пользователь',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: { full_name: string }) => {
          return value?.full_name || '';
        },
      },
    },
    {
      name: 'update_dt',
      label: 'Дата обновления',
      options: {
        filter: false,
        sort: false,
        customBodyRender: dateTimeBodyRender(false, false),
      },
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: {
          name: 'status_id',
          type: 'multi-select',
          sourceName: 'outlet_update_request_status'
        },
        sort: false,
        customBodyRender: entityBaseBodyRender(false),
      },
    },
    {
      name: 'outlet_id',
      label: 'Обновить мастер-ТТ',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) =>  {
          if (!canEdit) {
            return null;
          }
          return (
            <>
              {rowData.status.id === 1 && <IconButton
                onClick={() => {
                  history.push(`/acl/outlets/${id}/update`, {
                    update: rowData,
                  });
                } } aria-label="edit"
              >
                <PlayArrow />
              </IconButton>}
              {(rowData.status.id === 3 || rowData.status.id === 2) && <IconButton
                onClick={() => {
                  history.push(`/acl/updates-outlets/${id}/view`, {
                    update: rowData,
                  });
                } } aria-label="edit"
              >
                <FaEye />
              </IconButton>}
            </>
          );
        },
      },
    },
    {
      name: 'division',
      label: 'Дивизион',
      options: {
        hidden: true,
        sort: false,
        filter: {
          name: 'division_id',
          type: 'multi-select',
          sourceName: 'division',
        },
      }
    }
  ];
};
